import { FC } from 'react';

import styles from './KnmPreview.module.scss';

interface IKnmSubtitleProps {
  title: string;
}

export const KnmSubtitle: FC<IKnmSubtitleProps> = ({ title, children }) => (
  <>
    <span className={styles.SectionTitle}>{title}</span>
    <div>{children}</div>
  </>
);
